import { CloseButton } from '@chakra-ui/react';
import { FC } from 'react';

import { Alert, AlertDescription, AlertIcon } from '@bonusly/ds-alert';

import { toastSemanticColors, ToastStatus } from '../types';

export interface ToastProps {
	isCloseable?: boolean;
	message: string;
	onClose?: VoidFunction;
	status?: ToastStatus;
	marginTop?: number;
}

export const Toast: FC<ToastProps> = ({ isCloseable, message, onClose, status = 'info' }) => {
	const colors = toastSemanticColors[status];

	return (
		<Alert alignItems="center" status={status} boxShadow="md">
			<AlertIcon color={colors.icon} />
			<AlertDescription color={colors.text} flex={1} fontWeight="medium">
				{message}
			</AlertDescription>
			{isCloseable && (
				<CloseButton
					backgroundColor={colors.closeBg}
					borderRadius="full"
					color={colors.text}
					ml={2}
					onClick={onClose}
					_active={{
						backgroundColor: colors.closeBgActive,
					}}
					_hover={{
						backgroundColor: colors.closeBgHover,
					}}
				/>
			)}
		</Alert>
	);
};
